import React, { useState } from "react";
import { Button, Popover, Box, Typography, Stack } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import LockIcon from "@mui/icons-material/Lock";
import ActionButton from "./ActionButton";
import { copyToClipboard } from "../utils/copyToClipboard";
import { SEND_COLOR, SEND_COLOR_DARK } from "../../constants/colors";
import { FONT_SIZE } from "../../constants/fontSizes";

const ShareButton = ({ isPublic, shareUrl, onSettingsClick, isDesktop }) => {
  // Popoverを表示する位置の基準になる要素
  const [anchorEl, setAnchorEl] = useState(null);

  // 非公開時のPopover表示状態
  const open = Boolean(anchorEl);

  // 共有ボタンを押した時の処理
  const handleClick = (event) => {
    // 非公開ならPopover表示
    if (!isPublic) {
      setAnchorEl(event.currentTarget);
      return;
    }

    // 公開中なら共有リンクをコピー
    if (shareUrl) {
      copyToClipboard(shareUrl);
    }
  };

  // Popoverを閉じる
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={isPublic ? <LinkIcon /> : <LockIcon />}
        onClick={handleClick}
        sx={{
          width: isDesktop ? 130 : "50%",
          minWidth: 0,
          height: 40,
          borderRadius: "999px",
          textTransform: "none",
          fontWeight: 600,
          fontSize: FONT_SIZE.SM,
          boxShadow: "none",

          color: isPublic ? "#2563eb" : "#64748b",
          borderColor: isPublic ? "#bfdbfe" : "#cbd5e1",
          backgroundColor: isPublic ? "#eff6ff" : "#f8fafc",

          "& .MuiButton-startIcon": {
            mr: "8px",
          },

          "&:hover": {
            color: isPublic ? "#1d4ed8" : "#475569",
            borderColor: isPublic ? "#93c5fd" : "#94a3b8",
            backgroundColor: isPublic ? "#dbeafe" : "#f1f5f9",
            boxShadow: "none",
          },
        }}
      >
        共有リンク
      </Button>

      {/* 非公開時に表示する案内 */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              borderRadius: 3,
              boxShadow: "0 12px 32px rgba(15, 23, 42, 0.18)",
            },
          },
        }}
      >
        <Box
          sx={{
            p: 3,
            width: 300,
          }}
        >
          <Stack spacing={2.5}>
            <Stack spacing={1}>
              <Typography fontWeight={700} fontSize={16}>
                マイページは非公開です
              </Typography>

              <Typography fontSize={14} color="text.secondary" lineHeight={1.7}>
                公開設定をONにすると、
                マイページを外部ユーザーに公開することができます。
              </Typography>
            </Stack>

            <ActionButton
              label="公開設定へ"
              onClick={onSettingsClick}
              sx={{
                width: "100%",
                color: "#fff",
                backgroundColor: SEND_COLOR,
                "&:hover": {
                  backgroundColor: SEND_COLOR_DARK,
                },
              }}
            />
          </Stack>
        </Box>
      </Popover>
    </>
  );
};

export default ShareButton;
